import React from 'react';
import {BodyContainer} from "../Container/Container";
import styled from 'styled-components';
import {P2} from '../Kit/Kit';
import sideImg from '../../assets/img/productInfoSide.jpg';

const StyledBodyContainer = BodyContainer.extend`
  display: grid;
  grid-template-columns: 1fr;
  grid-row-gap: 18px;
  align-items: center;
  
  @media(min-width: 768px) {
      grid-template-columns: 3fr 2fr;
      grid-column-gap: 36px;
  }
  
  img {
    width: 100%;
    
    @media(min-width: 768px) {
      order: 1;
      align-self: start;
    }
  }
`;

const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  order: 2;
  
  @media(min-width: 768px) {
    order: 1;
  }
`;

const Text = styled.div`
  text-align: left;
  
  p{
      p:first-of-type {
          font-family: Cabin-Bold, sans-serif;
          color: #004a87;
          text-align: left;
          
          font-size: 14px;
          line-height: 1.5;
          z-index: 1;
          
          @media(min-width: 768px) {
            font-size: 12px;
          }
          
          @media(min-width: 992px) {
            font-size: 14px;
          }
          
           @media(min-width: 1200px) {
            font-size: 16px;
          }
          
           @media(min-width: 1680px) {
            font-size: 25px;
          }
      }
      
      p{
        text-align: left;
        margin-bottom: 20px;
         @media(min-width: 768px) {
          margin-bottom: 40px;
        }
      }
  }

  + p {
      p:first-of-type {
              font-family: Cabin-Bold, sans-serif;
              color: #004a87;
              text-align: left;
              
              font-size: 14px;
              line-height: 1.5;
              z-index: 1;
              
              @media(min-width: 768px) {
                font-size: 12px;
              }
              
              @media(min-width: 992px) {
                font-size: 14px;
              }
              
               @media(min-width: 1200px) {
                font-size: 16px;
              }
              
               @media(min-width: 1680px) {
                font-size: 25px;
              }
          }
          
          p{
            text-align: left;
            margin-bottom: 20px;
             @media(min-width: 768px) {
              margin-bottom: 40px;
            }
          }
      }
  }
`;

const Section2 = (props) => {
    const {content} = props;
    return (
      <StyledBodyContainer>
          <TextContainer>
              <Text>
                  <P2
                    dangerouslySetInnerHTML={{__html: content}}
                  />
              </Text>
          </TextContainer>
          <img src={sideImg} alt="Wholesale Seafood Handler"/>
      </StyledBodyContainer>
    );
};

export default Section2;



// WEBPACK FOOTER //
// ./src/components/ProductInfo/Section2.js